module.exports = __webpack_public_path__ + "static/img/mb-02.17375fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/w11/mb-02.jpg
// module id = T8kd
// module chunks = 1